import { Button, Grid2 } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import useAuthStore from '../../store/useAuthStore';
import { useToaster } from '../../shared/utils/ToasterProvider';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Grid_Gap, Input_Width } from '../../shared/constants';
import { TermAndConditionList } from '../../assets/api/useMarketingExecutive';
import api from '../../assets/nodeApi/axiosInstance';

const CommonTermAndConditionForm = ({ id }) => {
    const { data: termConditionList } = TermAndConditionList({ apartment_id: id })
    const { token } = useAuthStore()
    const { showToaster } = useToaster();
    const queryClient = useQueryClient();
    const validationSchema = Yup.object().shape({
        security_deposit: Yup.number()
            .typeError('Security deposit must be a number')
            .required('Security deposit is required')
            .min(0, 'Security deposit cannot be negative'),
        terms_conditions: Yup.string().required('Terms and conditions are required')
    });

    const initialValues = {
        security_deposit: "",
        terms_conditions: ""
    };


    // const mutation = useMutation({
    //     mutationFn: (formData) => {
    //         return termConditionList?.security_deposit
    //             ? api.put(`apartment-terms/${id}`, formData,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                 }
    //             )
    //             : api.post(`apartment-terms`, formData,
    //                 {
    //                     headers: {
    //                         Authorization: `Bearer ${token}`,
    //                     },
    //                 }
    //             );
    //     },
    //     onSuccess: (response) => {
    //         showToaster('Success', response?.data?.message, 'success')
    //         queryClient.invalidateQueries({ queryKey: ['apartment-terms/by-apartment'] });

    //     },
    //     onError: (error) => {
    //         const statusCode = error?.response?.status;
    //         if (statusCode === 401) {
    //             showToaster("Unauthorized. Please log in again.", 'Error', 'error');
    //         } else if (statusCode === 409) {
    //             showToaster(error?.response?.data?.message, 'Error', 'error');
    //         } else if (statusCode === 500) {
    //             showToaster("Server Error. Please try again later.", 'Error', 'error');
    //         } else {
    //             showToaster("Something went wrong", 'Error', 'error');
    //         }
    //     },
    // });

    const mutation = useMutation({
        mutationFn: (formData) => {
            api.post(`apartment-terms`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['apartment-terms/by-apartment'] });

        },
        onError: (error) => {
            const statusCode = error?.response?.status;
            if (statusCode === 401) {
                showToaster("Unauthorized. Please log in again.", 'Error', 'error');
            } else if (statusCode === 409) {
                showToaster(error?.response?.data?.message, 'Error', 'error');
            } else if (statusCode === 500) {
                showToaster("Server Error. Please try again later.", 'Error', 'error');
            } else {
                showToaster("Something went wrong", 'Error', 'error');
            }
        },
    });


    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        const obj = {
            apartment_id: Number(id),
            // status: 1,
            security_deposit: values.security_deposit,
            terms_conditions: values.terms_conditions
        }
        mutation.mutate(obj, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });

    }
    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ resetForm }) => (
                <Form>
                    <Grid2 container spacing={Grid_Gap}
                        sx={{ placeItems: "start" }}
                    >

                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                name="security_deposit"
                                component={TextFormField}
                                label="Enter Security Deposit"
                                isRequired={true}
                                type={"number"}
                            />
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                            <Field
                                name="terms_conditions"
                                component={TextFormField}
                                label="Enter Term And Condition"
                                isRequired={true}
                            // multiline
                            // row={4}
                            />
                        </Grid2>

                    </Grid2>
                    <CustomDivider />
                    <Grid2 container spacing={Grid_Gap}>
                        <Grid2 children size={Input_Width}>
                            <Button variant='contained' onClick={resetForm} fullWidth>
                                Cancel
                            </Button>
                        </Grid2>
                        <Grid2 children size={{ xs: 12, sm: 6, md: 4 }}>
                            <Button variant='contained' type='submit' fullWidth>  {termConditionList?.security_deposit ? "Edit" : "Submit"}</Button>
                        </Grid2>


                    </Grid2>
                </Form>
            )}
        </Formik>
    )
}

export default CommonTermAndConditionForm